<script setup>
import ChargerDialog from "../components/ChargerDialog.vue";
import RfidDialog from "../components/RfidDialog.vue";
import { statusName } from "../../lib/modules/ocpp.js";
import { useEvent, useFetch, useHttp } from "vutil";
import { ref } from "vue";

const props = defineProps(["id"]);

const { data, error, get } = useFetch(`/api/site/${props.id}/chargers`);
const { busy, data: chargeReady, error: chargeError, post } = useHttp(() => true);
const edit = ref(null);
const rfid = ref(null);

useEvent(document, "visibilitychange", () => !document.hidden && get());
</script>

<template>
	<div class="error">{{ error }}</div>
	<div v-if="data" class="list">
		<div v-if="data.length === 0">Ingen ladepunkter registrert</div>
		<div v-for="charger in data" :key="charger.id" class="charger">
			<div class="btns">
				<a class="ui-btn icon" :href="`/api/charger/${charger.id}/tag`" title="QR-kode"><img class="icon-tag"></a>
				<button class="ui icon" title="Sett ladebrikke" @click="rfid = charger"><img class="icon-key"></button>
				<button class="ui icon" title="Start lading" :disabled="busy" @click="post(`/api/charger/${charger.id}/charge`)"><img class="icon-play"></button>
			</div>
			<h2><a @click="edit = charger"><span v-if="charger.name">{{ charger.name }} • </span>{{ charger.sn }}</a></h2>
			<div class="model">{{ charger.model }} <i>{{ charger.fwver }}</i></div>
			<div class="state">
				<div :class="['status', charger.status]">{{ statusName(charger.status) }}</div>
				<div v-if="charger.reserved" class="reserved">Reservert</div>
				<div v-if="charger.error && charger.error !== 'NoError'" class="err">{{ charger.error }}</div>
			</div>
		</div>
	</div>
	<UiDialog v-if="chargeError" @close="chargeError = null">
		<h1>Charge Error</h1>
		<p class="error">{{ chargeError }}</p>
	</UiDialog>
	<UiDialog v-else-if="chargeReady" @close="chargeReady = false; get()">
		<h1>Charger Ready</h1>
	</UiDialog>
	<ChargerDialog v-else-if="edit" :charger="edit" @update="get(); edit = null" @close="edit = null"/>
	<RfidDialog v-else-if="rfid" :charger="rfid" @learn="rfid = null" @close="rfid = null"/>
</template>
